import { useSelector } from 'react-redux'
import { getActiveAttendantId, getAttendants } from '../../selectors/attendant'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { ToastManager } from '../../utils/toastManager'
import { APPLICATION_STRINGS } from '../../strings'
import createDataDogLog from '../../utils/datadog'

export const useVerifyCurrentAttendant = () => {
  const attendants = useSelector(getAttendants)
  const employeeId = useSelector(getActiveAttendantId)
  const history = useHistory()

  const verifyCurrentAttendant = (showToast = true) => {
    if (!attendants || attendants?.length === 0) {
      return undefined
    }

    if (employeeId) {
      return employeeId
    }

    history.push('/login')
    if (showToast) {
      ToastManager.error(APPLICATION_STRINGS.PLEASE_LOGIN, { autoClose: false })
      createDataDogLog('error', APPLICATION_STRINGS.PLEASE_LOGIN)
    }

    return undefined
  }

  return { verifyCurrentAttendant }
}
